/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const GET_SWATCH_TABS_METADATA = "GET_SWATCH_TABS_METADATA";
export const SET_SWATCH_TABS = "SET_SWATCH_TABS";
export const SET_LAST_KEY_WAS_TAB = "SET_LAST_KEY_WAS_TAB";